import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Anchor, Facebook, Waves, Star } from 'lucide-react';

const CoastalFooter = () => {
  // Google review link - searches for business to leave review
  const googleReviewLink = "https://www.google.com/search?q=Coastal+Flag+Company+Gulf+Coast&hl=en#lrd=";
  
  return (
    <footer className="bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white">
      {/* Review Banner */}
      <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center">
            <div className="flex items-center gap-2">
              <Star className="w-6 h-6 text-white fill-white" />
              <Star className="w-6 h-6 text-white fill-white" />
              <Star className="w-6 h-6 text-white fill-white" />
              <Star className="w-6 h-6 text-white fill-white" />
              <Star className="w-6 h-6 text-white fill-white" />
            </div>
            <span className="text-white font-semibold">Love our service?</span>
            <a 
              href={googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-yellow-600 px-6 py-2 rounded-full font-bold hover:bg-yellow-50 transition-colors"
            >
              Leave Us a Google Review!
            </a>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Anchor className="w-8 h-8 text-cyan-400" />
              <div>
                <h3 className="text-xl font-bold">
                  <span className="text-cyan-400">Coastal Flag</span>
                  <span className="block text-lg">Company</span>
                </h3>
              </div>
            </div>
            <p className="text-slate-300 mb-4">
              Gulf Coast's premier source for marine-grade flags and hurricane-resistant flagpoles. Quality products built for coastal conditions.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                <Facebook className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-cyan-400">Shop</h4>
            <ul className="space-y-2">
              <li><Link to="/us-flags" className="text-slate-300 hover:text-cyan-400 transition-colors">U.S. Flags</Link></li>
              <li><Link to="/state-flags" className="text-slate-300 hover:text-cyan-400 transition-colors">State Flags</Link></li>
              <li><Link to="/military" className="text-slate-300 hover:text-cyan-400 transition-colors">Military Flags</Link></li>
              <li><Link to="/marine" className="text-slate-300 hover:text-cyan-400 transition-colors">Marine & Nautical</Link></li>
              <li><Link to="/poles" className="text-slate-300 hover:text-cyan-400 transition-colors">Poles & Hardware</Link></li>
              <li><Link to="/custom" className="text-slate-300 hover:text-cyan-400 transition-colors">Custom Orders</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-cyan-400">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/installation" className="text-slate-300 hover:text-cyan-400 transition-colors">Mobile Installation</Link></li>
              <li><Link to="/custom" className="text-slate-300 hover:text-cyan-400 transition-colors">Custom Flag Design</Link></li>
              <li><Link to="/" className="text-slate-300 hover:text-cyan-400 transition-colors">Hurricane-Resistant Poles</Link></li>
              <li><Link to="/" className="text-slate-300 hover:text-cyan-400 transition-colors">Marine-Grade Products</Link></li>
              <li><Link to="/" className="text-slate-300 hover:text-cyan-400 transition-colors">Coastal Consultation</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-cyan-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Waves className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
                <span className="text-slate-300">Serving Sandestin, Santa Rosa Beach,<br />Panama City, Destin, 30A<br />& the entire Gulf Coast</span>
              </li>
              <li>
                <a href="tel:205-587-2402" className="flex items-center gap-2 text-slate-300 hover:text-cyan-400 transition-colors">
                  <Phone className="w-5 h-5 text-cyan-400" />
                  205-587-2402
                </a>
              </li>
              <li>
                <a href="mailto:coastalflagco@yahoo.com" className="flex items-center gap-2 text-slate-300 hover:text-cyan-400 transition-colors">
                  <Mail className="w-5 h-5 text-cyan-400" />
                  coastalflagco@yahoo.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Coastal Flag Company. All rights reserved. Made in USA.</p>
        </div>
      </div>
    </footer>
  );
};

export default CoastalFooter;